import {getOSCStatus, startOSCConnection, sendOscTriggerMessage, sendOscDirectMessage} from '../../osc'

// initial state
const state = {
  currentD3TrackName: null,
  lastD3Contact: null,
  wsConnection: 'unconnected',
  queuedOSC: null,
  OSCStatus: null
}

// getters
const getters = {
  currentD3TrackName: state => {
    return state.currentD3TrackName
  },
  lastD3Contact: state => {
    return state.lastD3Contact
  },
  wsConnection: state => {
    return state.wsConnection
  },
  queuedOSC: state => {
    return state.queuedOSC
  },
  OSCStatus: state => {
    return state.OSCStatus
  }
}

// actions
const actions = {
  getOSCStatus ({ commit }) {
    commit('setOSCStatus', getOSCStatus())
  },

  sendOscDirectMessage ({ commit }, { address, args }) {
    sendOscDirectMessage(address, args)
  },

  sendOscTriggerForced ({ commit }, trigger) {
    sendOscTriggerMessage(trigger)
  },

  sendOscTrigger ({ dispatch, commit, state }, cueId) {
    console.log(state.currentD3TrackName)
    if (state.currentD3TrackName === null || state.currentD3TrackName === 'idle') {
      sendOscTriggerMessage(cueId)
      commit('setQueueOSC', null) // reset to null ready for the next queued message
    } else {
      commit('setQueueOSC', cueId)
    }
  },

  handleRecievedTrackNameMessage ({ dispatch, commit, state }, { trackname }) {
    commit('setCurrentD3TrackName', trackname)
    
    // (re)dispatch any queued OSC messages 
    if(state.queuedOSC != null) {
      dispatch('sendOscTrigger', state.queuedOSC)
    }
  },

  handleWSOpen ({ commit }) {
    commit('setWSConnectionOpen')
  },
  
  resetWSState ({ commit }) {
    commit('setWSConnectionClosed')
  },

  startOSCConnection ({ commit }) {
    startOSCConnection()
  }
}

// mutations
const mutations = {
  setCurrentD3TrackName (state, trackname) {
    state.currentD3TrackName = trackname
    state.lastD3Contact = new Date()
  },

  setWSConnectionOpen (state) {
    state.wsConnection = 'open'
  },

  setWSConnectionClosed (state) {
    state.wsConnection = 'closed'
  },

  setQueueOSC (state, cue) {
    state.queuedOSC = cue
  },

  setOSCStatus (state, status) {
    state.OSCStatus = status
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
